import LocationEpisode from 'models/LocationEpisode';

import { PayerType } from '../shared/DischargeCalendarPatientCard';

export function getPayerType(entry: LocationEpisode): PayerType {
  const healthPlanName = entry.planTypeClassification?.parentClassification?.name?.toLowerCase() ?? '';
  const isMedicare = healthPlanName.includes('medicare');
  return isMedicare ? 'medicare' : 'other';
}
